import React from 'react';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { rachelZoePageData } from '@data-ts/pages/rachel-zoe';
import { CloudImage } from '@components/CloudImage';
import { QuoteTrackingText, QuoteColumn, ImageColumn } from './QuoteSection.styles';

const SECTION_ID = 'Rachel_Zoe_Quote';
const quoteData = rachelZoePageData.sections.quote;

export const QuoteSectionDesktop: React.FC = () => {
  return (
    <Box backgroundColor="white" paddingTop={[10, 11]} paddingBottom={12} id={SECTION_ID}>
      <Columns>
        <QuoteColumn desktopOffset={1} width="half">
          <QuoteTrackingText
            alignment="left"
            title={quoteData.title}
            titleColor="neutra6"
            titleVariant="hed72Hero"
            titleTagName="h2"
            eyebrow={quoteData.eyebrow}
            eyebrowVariant="sectionEyeBrow24"
            eyebrowColor="neutra6"
          />
        </QuoteColumn>
        <ImageColumn width="half">
          <CloudImage height="774px" width="603px" src="rachel zoe/quote/rz.jpg" alt="Quote Tracking" />
        </ImageColumn>
      </Columns>
    </Box>
  );
};
